'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

Object.defineProperty(exports, 'common', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_common).default;
  }
});

var _red = require('./red');

Object.defineProperty(exports, 'red', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_red).default;
  }
});

var _pink = require('./pink');

Object.defineProperty(exports, 'pink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pink).default;
  }
});

var _purple = require('./purple');

Object.defineProperty(exports, 'purple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_purple).default;
  }
});

var _deepPurple = require('./deepPurple');

Object.defineProperty(exports, 'deepPurple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepPurple).default;
  }
});

var _indigo = require('./indigo');

Object.defineProperty(exports, 'indigo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_indigo).default;
  }
});

var _blue = require('./blue');

Object.defineProperty(exports, 'blue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blue).default;
  }
});

var _lightBlue = require('./lightBlue');

Object.defineProperty(exports, 'lightBlue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightBlue).default;
  }
});

var _cyan = require('./cyan');

Object.defineProperty(exports, 'cyan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cyan).default;
  }
});

var _teal = require('./teal');

Object.defineProperty(exports, 'teal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_teal).default;
  }
});

var _green = require('./green');

Object.defineProperty(exports, 'green', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_green).default;
  }
});

var _lightGreen = require('./lightGreen');

Object.defineProperty(exports, 'lightGreen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightGreen).default;
  }
});

var _lime = require('./lime');

Object.defineProperty(exports, 'lime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lime).default;
  }
});

var _yellow = require('./yellow');

Object.defineProperty(exports, 'yellow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yellow).default;
  }
});

var _amber = require('./amber');

Object.defineProperty(exports, 'amber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_amber).default;
  }
});

var _orange = require('./orange');

Object.defineProperty(exports, 'orange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_orange).default;
  }
});

var _deepOrange = require('./deepOrange');

Object.defineProperty(exports, 'deepOrange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepOrange).default;
  }
});

var _brown = require('./brown');

Object.defineProperty(exports, 'brown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_brown).default;
  }
});

var _grey = require('./grey');

Object.defineProperty(exports, 'grey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_grey).default;
  }
});

var _blueGrey = require('./blueGrey');

Object.defineProperty(exports, 'blueGrey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blueGrey).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/colors/index.js
// module id = 698
// module chunks = 0